/**
 * Returns a localized error message based on the given error type.
 * @param {PageErrorProps['type']} type - The type of error (e.g., 'not-found', 'access-issue').
 * @param {TFunction<'common-web-ui', undefined>} t - The translation function for localized messages.
 * @returns {string | undefined} The localized error message, or undefined if not available for the type.
 */
export function getDefaultErrorMessage(type, t) {
    switch (type) {
        case 'not-found':
            return t('pageError.messageNotFound');
        case 'access-issue':
            return t('pageError.messageAccessIssue');
        default:
            return undefined;
    }
}
